module.exports = __webpack_public_path__ + "img/burger.22111b66.svg";